export const IGNICIONES = [
	{ id: 0, nombre: 'Apagado' },
	{ id: 1, nombre: 'Encendido' },
	{ id: null, nombre: 'Sin Datos' },
];

export const ESTATUS = [
	{ id: 0, nombre: 'Inactivo', clase: 'gris' },
	{ id: 1, nombre: 'Activo',clase: 'verde' },
	{ id: null, nombre: 'Sin Datos', clase: 'gris' }
];

export const ALIMENTACION = [
	{ id: 0, nombre: 'Desconectado'},
	{ id: 1, nombre: 'Conectado'},
	{ id: null, nombre: 'Sin Datos'}
]

export const ALERTAS = [
	{ id: 0, nombre: 'Detenido', clase: 'gris', icono: './assets/media/marcadores/flechaGris.png'},
	{ id: 1, nombre: 'Movimiento', clase: 'verde', icono: './assets/media/marcadores/flechaVerde.png' },
	{ id: 2, nombre: 'Alerta Primaria', clase: 'naranja', icono: './assets/media/marcadores/flechaRoja.png'},
	{ id: 3, nombre: 'Alerta Secundaria',  clase: 'amarillo', icono: './assets/media/marcadores/flechaAmarilla.png'},
	{ id: 4, nombre: 'Detenido mas de 30 min', clase: 'amarillo', icono: './assets/media/marcadores/flechaAmarilla.png'},
	{ id: 5, nombre: 'Detenido mas de 60 min', clase: 'naranja', icono: './assets/media/marcadores/flechaNaranja.png'},
	{ id: 6, nombre: 'Detenido mas de 90 min', clase: 'rojo', icono: './assets/media/marcadores/flechaRoja.png' },
	{ id: 7, nombre: 'Exceso de Velocidad', clase: 'azul', icono: './assets/media/marcadores/flechaAzul.png'},
	{ id: 8, nombre: 'Fuera de Geocerca', clase: 'morado', icono: './assets/media/marcadores/flechaMorada.png' },
	{ id: 9, nombre: 'Batería Baja', clase: 'cafe', icono: './assets/media/marcadores/flechaRosa.png'},
	{ id: 10, nombre: 'Falta de Energía', clase: 'rosa', icono: './assets/media/marcadores/flechaCafe.png'},
	{ id: 11, nombre: 'Alerta de Movimiento', clase: 'gris', icono: './assets/media/marcadores/flechaGris.png' },
	{ id: null, nombre: 'Sin Datos', clase: 'gris', icono: './assets/media/marcadores/flechaGris.png'}
];

export const GSM = [
	{ id: 0, nombre: 'Desconocida' },
	{ id: 1, nombre: 'Mínima' },
	{ id: 2, nombre: 'Moderada' },
	{ id: 3, nombre: 'Buena' },
	{ id: 4, nombre: 'Excelente' },
	{ id: 5, nombre: 'Desconocida' },
	{ id: null, nombre: 'Desconocida' }
];

export const GPS = [
	{ id: null, nombre: 'Mala', clase: 'rojo' },
	{ id: 0, nombre: 'Mala', clase: 'rojo' },
	{ id: 1, nombre: 'Buena', clase: 'verde' },
	{ id: 2, nombre: 'Buena', clase: 'verde' },
	{ id: 3, nombre: 'Buena', clase: 'verde' },
	{ id: 4, nombre: 'Buena', clase: 'verde'},
	{ id: 5, nombre: 'Media', clase: 'naranja' },
	{ id: 6, nombre: 'Media', clase: 'naranja' },
	{ id: 7, nombre: 'Media', clase: 'naranja' },
];
